import log from 'loglevel';

/**
 * Utilities for consistent logging throughout the application
 */

/**
 * Create a named logger with default error level
 * @param {string} name - The name for the logger, typically the component/controller name
 * @returns {object} - The configured logger instance
 */
export function createLogger(name) {
  const logger = log.getLogger(name);
  logger.setLevel("error");

  if (!logger._rollbarWrapped) {
    const originalError = logger.error.bind(logger);
    logger.error = function(...args) {
      if (typeof Rollbar !== 'undefined') {
        Rollbar.error('[' + name + ']', ...args)
      }
      originalError(...args);
    }
    logger._rollbarWrapped = true;
  }

  return logger;
}

/**
 * Convert a DOM node to a readable string representation
 * @param {Node} node - The DOM node to stringify
 * @returns {string} - String representation of the node
 */
export function nodeToString(node) {
  if (!node) return 'undefined-node';

  const toKebabCase = str => str.replace(/[A-Z]/g, match => '-' + match.toLowerCase());

  const datasetString = Object.entries(node.dataset)
    .map(([key, value]) => `[data-${toKebabCase(key)}="${value}"]`)
    .join('');

  const idString = node.id ? `#${node.id}` : '';
  const classString = node.className ? '.' + node.className.trim().replace(/\s+/g, '.') : '';

  return `${node.tagName}${idString}${classString}${datasetString}`;
}


